import React from "react";

function Footer() {
  return (
    <footer className="w-full py-6 text-center text-gray-500 text-sm bg-gray-100 mt-auto">
      &copy; {new Date().getFullYear()} Aplikacija za analizo učnih načrtov. Vse pravice pridržane.
    </footer>
  );
}

export default Footer;
